import styles from './AiRecommendations.module.css';
import { colorForCriterion } from './recommendationModel';

const TYPE_LABEL = { appearance: '사진', fact: '프로필' };

/** 평가 기준 범례: 색 · 이름 · 가중치. 정의는 마우스를 올리면 보인다. */
export default function CriteriaLegend({ criteria }) {
  if (!criteria?.length) return null;
  return (
    <ul className={styles.legend} aria-label="평가 기준">
      {criteria.map((c, i) => (
        <li key={c.id} className={styles.legendItem} title={c.definition || undefined}>
          <span className={styles.legendSwatch} style={{ background: colorForCriterion(i) }} aria-hidden="true" />
          <span className={styles.legendLabel}>{c.label}</span>
          <span className={styles.legendWeight}>{c.weight}%</span>
          {TYPE_LABEL[c.type] && <span className={styles.legendType}>{TYPE_LABEL[c.type]}</span>}
        </li>
      ))}
    </ul>
  );
}
